import { NavLink, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { firebaseApp } from "../lib/firebase";

const navItems = [
  { to: "/", label: "Command Center", end: true },
  { to: "/journal", label: "Journal" },
  { to: "/story", label: "Story" },
  { to: "/growth", label: "Growth" },
  { to: "/community", label: "Community" },
  { to: "/product-quality", label: "Product Quality" },
  { to: "/users", label: "Users" },
  { to: "/moderation", label: "Moderation" },
  { to: "/verification", label: "Verification" },
  { to: "/revenue", label: "Revenue" },
  { to: "/founder-finance", label: "Founder Finance" },
  { to: "/coaches", label: "Coaches" },
  { to: "/shout-outs", label: "Shout-Outs" },
  { to: "/system-health", label: "Infrastructure" }
];

const pageTitles: Record<string, string> = {
  "/": "Founder Command Center",
  "/journal": "Founder's Journal",
  "/story": "Founder Story",
  "/growth": "Founder Growth",
  "/community": "Founder Community",
  "/product-quality": "Founder Product Quality",
  "/users": "Users",
  "/moderation": "Moderation",
  "/verification": "Verification",
  "/revenue": "Revenue",
  "/founder-finance": "Founder Finance",
  "/coaches": "Coaches",
  "/shout-outs": "Shout-Outs",
  "/system-health": "Founder Infrastructure"
};

export default function AdminLayout() {
  const location = useLocation();
  const { signOutAdmin, user } = useAuth();
  const pageTitle = pageTitles[location.pathname] ?? "Chor Admin Center";

  return (
    <div className="admin-shell">
      <aside className="sidebar" aria-label="Admin navigation">
        <div className="brand-block">
          <span className="brand-mark">C</span>
          <div>
            <p className="brand-name">Chor</p>
            <p className="brand-context">Admin Center</p>
          </div>
        </div>

        <nav className="sidebar-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </aside>

      <div className="content-shell">
        <header className="topbar">
          <div>
            <p className="eyebrow">Admin only</p>
            <h1>{pageTitle}</h1>
          </div>

          <div className="identity-area">
            <div>
              <p className="identity-name">{user?.email ?? "Chor Admin"}</p>
              <p className="identity-meta">{firebaseApp.options.projectId}</p>
            </div>
            <button type="button" className="secondary-button" onClick={() => void signOutAdmin()}>
              Sign out
            </button>
          </div>
        </header>

        <main className="page-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
